import { render, staticRenderFns } from "./injuredList.vue?vue&type=template&id=8eafa0a0"
import script from "./injuredList.vue?vue&type=script&lang=js"
export * from "./injuredList.vue?vue&type=script&lang=js"
import style0 from "./injuredList.vue?vue&type=style&index=0&id=8eafa0a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports